import type { TachoCardLanguage } from "@/lib/aiWidgetTachoParser"
import { TACHO_CARD_STRINGS } from "../tachoCard/tachoCardStrings"

type OrderCardStrings = {
  title: (orderNumber: string) => string
  states: { done: string; here: string; ahead: string }
  eta: string
  hereSince: string
  withRest: (duration: string) => string
  late: (duration: string) => string
  next: (km: string, driving: string) => string
  weekdays: Record<string, string>
}

const pl: OrderCardStrings = {
  title: (n) => `Zlecenie #${n}`,
  states: { done: "zrobiony", here: "na miejscu", ahead: "przed nim" },
  eta: "ETA",
  hereSince: "na miejscu od",
  withRest: (d) => `z pauzą ${d}`,
  late: (d) => `spóźnienie ${d}`,
  next: (km, driving) => `Do najbliższego przystanku: ${km} · ${driving} jazdy`,
  weekdays: TACHO_CARD_STRINGS.pl.weekdays,
}

const en: OrderCardStrings = {
  title: (n) => `Order #${n}`,
  states: { done: "done", here: "at the stop", ahead: "ahead" },
  eta: "ETA",
  hereSince: "at the stop since",
  withRest: (d) => `with a ${d} rest`,
  late: (d) => `late ${d}`,
  next: (km, driving) => `To the next stop: ${km} · ${driving} of driving`,
  weekdays: TACHO_CARD_STRINGS.en.weekdays,
}

export const ORDER_CARD_STRINGS: Record<TachoCardLanguage, OrderCardStrings> = {
  pl,
  en,
}

export type { OrderCardStrings }
